<template>
  <v-container class="pa-0">
    <v-row align="center" justify="center" :style="contentsHeight">
      <v-col cols="6" class="pa-1">
        <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
        <v-toolbar dark flat color="primary" class="rounded-t-xl">
          <v-spacer></v-spacer>
          <v-toolbar-title>新規登録</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card class="pa-1 rounded-b-xl" elevation="0" outlined>
          <v-row align="center" class="ma-0">
            <v-col cols="12" class="py-0" align="end">
              <small>*</small><small class="error--text font-weight-bold caption">必須</small>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="12" class="py-0" align="center">
              <v-checkbox
                v-model="pp"
                :rules="[rules.required]"
                color="error"
              >
                <template slot="label">
                  <span class="px-2">*</span>
                  <v-btn small depressed rounded outlined color="error" @click.stop="onTOS()">利用規約</v-btn>
                  <span class="caption">&nbsp;および&nbsp;</span>
                  <v-btn small depressed rounded outlined color="error" @click.stop="onPP()">個人情報保護</v-btn>
                  <span class="caption">&nbsp;に同意します。&nbsp;</span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="pa-0">
              <p style="text-align: center; font-size:12px;">本サービスのご利用には、<a href="https://www.google.com/chrome/" target="blank">Google Chrome</a>ブラウザをお使いください</p>
            </v-col>
          </v-row>
          <v-divider v-if="pp"></v-divider>
          <v-row v-if="pp"  align="center" justify="center" class="ma-0">
            <v-col cols="8" class="py-0" align="center">
             <v-text-field
                ref="id"
                prepend-icon="mdi-security"
                name="ID"
                label="* 利用者登録ID"
                placeholder=""
                v-model="id"
                type="text"
                class="title"
                clearable
                :rules="[rules.required, rules.entry]"
                ></v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <span>Google アカウントを</span><span class="font-weight-bold">お持ちの</span><span>方はこちらから</span>
            </v-col>
            <v-col cols="12" align="center" class="py-0">
              <v-btn rounded color="primary" depressed @click="googleLogIn" :disabled="!pp">認証</v-btn>
            </v-col>
            <v-col cols="12" align="center">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" align="center">
              <span>Google アカウントを</span><span class="font-weight-bold">お持ちでない</span><span>方はこちら</span>
            </v-col>
            <v-col cols="12" class="px-4" align="center">
              <v-form v-model="rules.valid">
                <v-text-field
                  id="email"
                  ref="email"
                  autocomplete="off"
                  prepend-icon="email"
                  name="login"
                  label="*メールアドレス"
                  v-model="email"
                  type="email"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
                <v-text-field
                  id="password"
                  ref="password"
                  autocomplete="off"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  prepend-icon="lock"
                  name="password"
                  label="*パスワード"
                  v-model="password"
                  :type="show1 ? 'text' : 'password'"
                  :rules="[rules.required, rules.min]"
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-text-field
                  id="confirmPassword"
                  ref="confirmPassword"
                  autocomplete="off"
                  :append-icon="show2 ? 'visibility' : 'visibility_off'"
                  prepend-icon="lock"
                  name="confirmPassword"
                  label="*パスワード（確認）"
                  v-model="confirmPassword"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  :rules="[rules.required, rules.min, rules.password]"
                ></v-text-field>
              </v-form>
            </v-col>
            <v-col cols="12" class="pa-0" align="center">
              <v-btn rounded color="primary" depressed @click="onSignup" :disabled="!(rules.valid && pp)">登録</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-dialog v-model="tospp"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-tos-pp
          @dismissed="onDismissed"
          :dialog='tospp'
          :type='type'
          :close="true"
        >
        </app-tos-pp>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      tospp: false,
      pp: false,
      show1: false,
      show2: false,
      type: null,
      id: null,
      email: '',
      password: '',
      confirmPassword: '',
      save: true,
      rules: {
        valid: false,
        required: value => !!value || '必須',
        password: value => value === this.password || 'パスワードが一致しません',
        min: v => v.length >= 6 || '最低でも 6文字が必要です',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '無効なメールアドレスです'
        },
        entry: value => {
          const pattern = /^[a-zA-Z0-9]{10}$/
          return pattern.test(value) || '無効な文字が含まれています'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      error: 'shared/error',
      loading: 'shared/loading',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40) + 'px;'
    }
  },
  methods: {
    googleLogIn () {
      var vm = this
      if (this.$refs.id.validate(true)) {
        this.$store.dispatch('auth/checkID', { id: this.id }).then(function (resp) {
          if (resp) {
            localStorage.id = vm.id
            localStorage.school = resp.key
            vm.$store.dispatch('auth/googleLogIn')
          }
        })
      }
    },
    onSignup () {
      var vm = this
      if (this.$refs.email.validate(true) &&
          this.$refs.password.validate(true) &&
          this.$refs.confirmPassword.validate(true) &&
          this.$refs.id.validate(true)) {
        this.$store.dispatch('auth/checkID', { id: this.id }).then(function (resp) {
          if (resp) {
            localStorage.email = vm.email
            localStorage.id = vm.id
            localStorage.school = resp.key
            vm.$store.dispatch('auth/signUserUp', { email: vm.email, password: vm.password })
          }
        })
      }
    },
    onTOS () {
      this.type = 'tos'
      this.tospp = true
    },
    onPP () {
      this.type = 'pp'
      this.tospp = true
    },
    onDismissed () {
      this.$store.dispatch('shared/setError', null)
      this.tospp = false
    }
  }
}
</script>

<style>
</style>
